// src/components/layout/Footer.tsx
import React from 'react';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`w-full text-white py-3 px-6 border-t border-gray-200 ${className}`} style={{ backgroundColor: 'var(--brand-primary)' }}>
      <div className="flex flex-col sm:flex-row justify-between items-center text-sm">
        {/* Información de copyright */}
        <div className="flex items-center space-x-2 mb-2 sm:mb-0">
          <span className="font-medium">© {currentYear} Bienesys</span>
          <span className="text-gray-300">|</span>
          <span className="text-gray-300">Todos los derechos reservados</span>
        </div>
        
        {/* Información adicional */}
        <div className="flex items-center space-x-4 text-gray-300">
          <span className="hidden sm:inline">Sistema de Gestión Bienesys</span>
          <span className="text-xs bg-white/10 px-2 py-1 rounded">
            v1.0.0
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
